<template>
  <component :is="activeComponent" />
</template>

<script>
import StandardOrder from "./Order/StandardOrder.vue";
import store from "@/store/store";

export default {
  name: "OrderSwitcher",
  components: {
    StandardOrder,
  },
  computed: {
    activeComponent() {
      return "StandardOrder";
    },
  },
  beforeRouteEnter(to, from, next) {
    const proceed = () => {
      if (store.getters["config/isKioskMode"]) {
        next({
          name: "OrderV2",
          params: to.params,
          query: to.query,
          replace: true
        });
      } else {
        next();
      }
    };
    if (!store.getters["config/terminal"]) {
      store.dispatch("config/fetchTerminal").then(proceed).catch(() => next());
    } else {
      proceed();
    }
  }
};
</script>
